import { feature as graphQLClientFeature } from '@central-products/graphql-client';

export const graphqlClientPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    addBootstrapperFeature(graphQLClientFeature, params);
  },
};
